module.exports = __webpack_public_path__ + "img/mo.54301d57.svg";